var _style, _g, _ellipse, _ellipse2, _path, _path2, _path3, _g2, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 162.7 162.7",
    style: {
      enableBackground: "new 0 0 162.7 162.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#F9D8D9;stroke:#3B3C3C;stroke-width:5.6693;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st2{fill:#FBE6E7;stroke:#3B3C3C;stroke-width:5.6693;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#3B3C3C;stroke-width:2.8346;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:#3B3C3C;}\n\t.st5{fill:#54494B;stroke:#3B3C3C;stroke-width:5.6693;stroke-linecap:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.15
    },
    width: 169,
    height: 170,
    xlinkHref: "DB0F02CC357D3778.png",
    transform: "matrix(1 0 0 1 -3.5039 -0.8039)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 81.3,
    cy: 81.3,
    r: 75.6
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 123.9,
    cy: 102.4,
    rx: 11.9,
    ry: 13.9
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 38.8,
    cy: 102.8,
    rx: 11.9,
    ry: 13.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.2,78.5L122.2,78.5c0-20.1-18.5-36.4-41.3-36.4S39.6,58.4,39.6,78.5V96h0c0.1,20,18.6,36.2,41.3,36.2 S122.1,116,122.2,96h0V78.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M57.9,88c1.9-2.8,5.7-4.3,9.7-3.6c3.3,0.6,5.9,2.5,7.2,4.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M104,88c-1.9-2.8-5.7-4.3-9.7-3.5c-3.3,0.6-5.9,2.5-7.2,4.9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 68.5,
    cy: 95.7,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 93.4,
    cy: 95.7,
    r: 3.9
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M43,76.4c0,0,2.8,5.2,10.3,4.5s15.1-8.9,15.1-8.9s1.8,4.6,6.8,4.6c4.9,0,6.5-4.6,6.5-4.6s0.5,4.3,5.5,4.3 c5.1,0,7.8-4.3,7.8-4.3s6.6,9.1,14.1,9.1c7.5,0,11.4-6,11.4-6v16.6c4.6-6.1,7.2-13.4,7.2-21.2c0-22-20.9-39.9-46.8-39.9 S34.1,48.3,34.1,70.3c0,8.7,3.3,16.8,8.9,23.4V76.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M69.7,106.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.2,115.5c0,0,9.8,0.4,13.2-2s1.2-3.9,1.2-3.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.2,106.9c0,0,2.5,1.1,2.3,2.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon5);
export default __webpack_public_path__ + "static/media/Education-Icon_5.4028a00762374e446e90c6cf0125b5fd.svg";
export { ForwardRef as ReactComponent };